import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  text?: string
}

export function LoadingSpinner({
  className,
  size = 'md',
  showText = true,
  text,
}: LoadingSpinnerProps) {
  const { t } = useTranslation()
  const loadingText = text || t('common.loading.default')
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-12 w-12 border-4',
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] space-y-4">
      <div
        className={cn(
          'animate-spin rounded-full border-t-transparent border-primary',
          sizeClasses[size],
          className
        )}
      />
      {showText && <p className="text-sm text-muted-foreground animate-pulse">{loadingText}</p>}
    </div>
  )
}
